// ANCHOR React
import { memo } from 'react';

// ANCHOR Base
import { styled } from 'baseui';
import { Block } from 'baseui/block';

// ANCHOR Constants
import { EMPTY_STATE_IMG, DEFAULT_IMG_ALT } from './constants';

// ANCHOR Styles
import { BLOCK } from './styles';

interface IProps {
  imgAlt?: string;
  type: 'default' | 'event' | 'thumbnail' | 'course';
}

const Image = styled('img', {
  width: '100%',
  height: '100%',
  objectFit: 'contain',
});

export const LyonEmptyStateImage = memo(({ type, imgAlt }: IProps) => (
  <Block overrides={BLOCK}>
    <Image
      src={EMPTY_STATE_IMG[type]}
      alt={imgAlt || DEFAULT_IMG_ALT[type]}
    />
  </Block>
));
